import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { IndexFilter } from '../../../../services/properties/schema/IndexFilterSchema';

interface ActiveStatusComponentProps {
    control: Control<IndexFilter>,
    errors: FieldErrors<IndexFilter>
}

const options = [
    { value: '', label: 'All Status' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
];

const ActiveStatusComponent: React.FC<ActiveStatusComponentProps> = ({ control, errors }) => {
    return (
        <div className='form-group'>
            <label className='form-label'>Status</label>
            <Controller
                control={control}
                name='is_property_active'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.is_property_active })}
                        options={options}
                        value={options.find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                        defaultValue={options[0]}
                    />
                )}
            />
            {errors.is_property_active && <div className="invalid-feedback">{errors.is_property_active.message}</div>}
        </div>
    )
}

export default ActiveStatusComponent
